export const Role = {
    FrontOffice: 'FrontOffice',
    Coach: 'Coach',    
    Admin: 'Admin',
    FrontOfficePlusCoach: 'FrontOfficePlusCoach'
}